// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const NaturalZinc = {
  productCode: "SBOVZ-Zinc",
  productName: " Natural Zinc ",
  ingredients: "Lentinula edodes",
  overview:"Orgavitaz-Zinc is an extract blend of mushrooms standardized for Natural and Food Zinc nutrition. Mushrooms as a blend in Orgavitaz Zn provides adequate amounts of natural zinc required for human health. ",
  assay:" Natural Iron 5 %",
  coNutrients:"Protein, soluble dietary fibre and essential amino acids are highly available in mushroom and have a significant role in malnutrition. Antioxidant ergothioneine helps fights organs from free radicals and oxidation. Co-nutrients in the form of essential amino acids and polysaccharides helps fight cancer and improve immunity. Other minerals present in Orgavitaz-Zn mushroom blend promote immune function and reduces build-up of DHT, anti-aging effects. ",
  studies:"Comprehensive Stability studies, Permeability assays for analysing zinc absorption.",
  benefits:"Zinc participates in more than 200 enzymatic reactions in the body and plays a critical role in synthesis and stabilization of genetic material. Zinc is necessary for the production of neurotransmitters in the brain. Intake of zinc is essential for normal fetal growth, normal development of male sex hormones and the prostate.",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/NaturalZinc/Z1.png",
     "images/Portfolio/OrgavitazForDeficiencies/NaturalZinc/Z2.png",
    "images/Portfolio/OrgavitazForDeficiencies/NaturalZinc/Z3.png",
    "images/Portfolio/OrgavitazForDeficiencies/NaturalZinc/Z4.png",



  ],
  certificates: [
   "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default NaturalZinc;
